// src/i18n/strings.js

const strings = {
  en: {
    // --- App / Geral ---
    appTitle: "Retrô Box Editor",
    loading: "Loading...",
    yes: "Yes",
    no: "No",
    ok: "OK",
    cancel: "Cancel",
    confirm: "Confirm",
    close: "Close",

    // --- Menu ---
    menuFile: "File",
    menuFileNewFeed: "New Feed",
    menuFileOpenFeed: "Open Feed",
    menuFileSaveFeed: "Save Feed",
    menuFileSaveAs: "Save As...",
    menuFileClose: "Close",

    menuEdit: "Edit",
    menuEditUndo: "Undo",
    menuEditRedo: "Redo",

    menuView: "View",
    menuViewPreviewFeed: "Preview Feed",
    menuViewTheme: "Theme",
    menuViewThemeLight: "Light",
    menuViewThemeDark: "Dark",

    menuHelp: "Help",
    menuHelpDocs: "Documentation",
    menuHelpAbout: "About Retrô Box Editor",

    // --- Tela inicial / Home ---
    homeTitle: "Edit Feeds",
    homeNewFeedButton: "Create New Feed",
    homeOpenFeedButton: "Open Feed",
    homeRecentFeeds: "Recent Feeds",
    homeSettings: "Settings",
	
	// --- MainAppBar ---
	mainAppBarTitle: "My Retro Box Feed Editor",
	mainAppBarSettings: "Settings",
	mainAppBarHelp: "Help",

    // --- Sidebar ---
    sidebarFeeds: "Feeds",
    sidebarCategories: "Categories",
    sidebarAddCategory: "Add Category",
    sidebarAddItem: "Add Item",
    sidebarSearchPlaceholder: "Search...",
    sidebarNoResults: "No results",

    // --- Categorias ---
    categoryName: "Category Name",
    categoryDelete: "Delete Category",
    categoryDeleteConfirm: "Are you sure you want to delete this category?",

    // --- Itens / Jogos ---
    itemTitle: "Item Title",
    itemDescription: "Description",
    itemThumbnail: "Thumbnail",
    itemBackgroundImage: "Background Image",
    itemLaunchCommand: "Launch Command",
    itemSystem: "System",
    itemRomUrl: "ROM URL",
    itemContentUrl: "Content URL",
    itemBoxArt: "Box Art",
    itemSaveChanges: "Save Changes",
    itemDelete: "Delete Item",
    itemDeleteConfirm: "Are you sure you want to delete this item?",

    // --- Diálogos de Feed ---
    dialogNewFeedTitle: "Create New Feed",
    dialogNewFeedNameLabel: "Feed Name",
    dialogNewFeedDescriptionLabel: "Feed Description",
    dialogNewFeedCreateButton: "Create",

    dialogOpenFeedTitle: "Open Feed URL",
    dialogOpenFeedUrlLabel: "Feed URL",
    dialogOpenFeedLoadButton: "Load",

    dialogSaveFeedExportTitle: "Export Feed",
    dialogSaveFeedExportMessage: "Enter a file name to export your feed",
    dialogSaveFeedExportButton: "Export",

    // --- Mensagens / Erros ---
    msgInvalidFeed: "Invalid feed.",
    msgUnableToLoadFeed: "Unable to load feed.",
    msgFeedSaved: "Feed saved successfully.",
    msgFeedSaveError: "Error saving feed.",
    msgMissingRequiredFields: "Missing required fields.",
    msgNetworkError: "Network error.",
    msgInvalidUrl: "Invalid URL.",
    msgUnsupportedFormat: "Unsupported format.",
    msgInvalidFile: "The selected file is not valid.",

    // --- Configurações ---
    settingsTitle: "Editor Settings",
    settingsLanguage: "Language",
    settingsTheme: "Theme",
    settingsDeveloperTools: "Developer Tools",
    settingsClearCache: "Clear Cache",
    settingsResetDefaults: "Reset to Defaults",
	
	// --- AINDA SEM CATEGORIA ---
	confirmYes: "Yes",
	confirmNo: "No",
	confirmDefaultTitle: "Confirm",
	confirmDefaultMessage: "Are you sure?",



	feedTabCategories: "Categories",
	feedTabItems: "Items",

	categoriesToolbarNew: "New",

	selectedFeedEditTooltip: "Edit feed",
	
    // --- Editor Drawer Lateral ---
   
    editorDrawerNew: "New",
	editorDrawerImport: "Import",
	editorDrawerExport: "Export",
	editorDrawerTest: "Test",
	editorDrawerLoad: "Load",
	editorDrawerSave: "Save",
	editorDrawerTools: "Tools",

	editorDrawerImportTooltip: "Import a feed from a URL or local file.",
	editorDrawerExportTooltip: "Export and download the feed.",
	editorDrawerTestTooltip: "Test the feed in the Meu Retrô Box front-end.",
	editorDrawerLoadTooltip: "Load feed.",
	editorDrawerSaveTooltip: "Save the feed locally.",

	msgSavingFeed: "Saving feed...",
	msgFeedSavedSuccess: "Successfully saved feed.",
	msgFeedSavedError: "Error saving feed.",
	dialogSaveFeedTitle: "Save Feed",
	dialogSaveFeedOverwriteMessage: "Continue and overwrite the existing feed?",
	
	// --- Dialogos de Tela
	importDialogTitle: "Import Feed",
	importDialogTabUrl: "URL",
	importDialogTabFile: "File",
	importDialogFeedUrl: "Feed location (URL)",
	importDialogSelectFile: "Select feed file...",
	msgImportingFeed: "Importing feed...",

	// --- Dialogo de Export ---
	exportDialogTitle: "Export Feed",
	exportDialogTabExport: "Export",

	exportDialogCompressLabel: "Compress (zip)",
	exportDialogCompressTooltip: "Whether to zip the feed.",
	exportDialogBase64Label: "Base64 encoding (text)",
	exportDialogBase64Tooltip: "Whether to Base64 encode the feed.",	


	// --- Feed Dialogos ---
	feedEditorTitle: "Edit Feed",
	feedEditorTabGeneral: "General",
	feedEditorTabProperties: "Properties",
	feedEditorTabThumbnail: "Thumbnail",
	feedEditorTabBackground: "Background",

	feedPropsApplicationLabel: "Application",
	feedPropsApplicationTooltip: "The application (emulator, etc.) to edit feed settings for.",

	feedPropsAtari5200RomUrl: "Atari 5200 ROM (URL)",
	feedPropsColecoRomUrl: "Coleco ROM (URL)",
	feedPropsFdsBiosUrl: "Famicom Disk System ROM (URL)",
	feedPropsLynxBootRomUrl: "Lynx Boot ROM (URL)",
	feedPropsNeoGeoBiosUrl: "Neo Geo BIOS (URL)",
	feedPropsNeoGeoCdBiosUrl: "Neo Geo CD BIOS (URL)",
	feedProps3doBiosUrl: "3DO BIOS (URL)",
	feedProps3doFontsUrl: "3DO Fonts (URL)",
	feedProps3doFontsHelper: "Required for some Japanese games (optional)",
	feedPropsPcecdBiosUrl: "PC Engine CD BIOS (URL)",
	feedPropsPcfxBiosUrl: "PC-FX BIOS (URL)",
	feedPropsPsxBiosUrls: "PlayStation BIOS (URLs)",
	feedPropsDsBiosUrls: "Nintendo DS (URLs)",
	feedPropsDsNickname: "Nickname",
	feedPropsSegacdBiosUrls: "Sega CD BIOS (URLs)",
	feedPropsCommodore8bitBiosUrls: "Commodore (8-bit) BIOS (URLs)",
	
	// --- Aba Geral 
	generalTabTitle: "Title",
	GeneralTabTitleLabel: "Title",
	generalTabLongTitle: "Long title",
	generalTabDescription: "Description",

	// --- Categorias editor
	categoriesHeaderTitle: "Title",
	categoriesHeaderEdit: "Edit",
	categoriesHeaderItemCount: "Item Count",

	categoriesTooltipEdit: "Edit category",

	categoriesToolbarCreate: "Create Category",
	categoriesToolbarMoveUp: "Move Up",
	categoriesToolbarMoveDown: "Move Down",
	categoriesToolbarCopy: "Copy",
	categoriesToolbarPaste: "Paste",
	categoriesToolbarDelete: "Delete",
	categoriesToolbarMore: "More",
	
	//-- Editar Fedd
	selectedFeedEdit: "Edit feed",
	
	//-- Feed Dialog
	loadFeedDialogTitle: "Load Feed",
	loadFeedDialogTabLoad: "Load",
	
	//--- Feed Tables
	feedTabsCategories: "Categories",
	feedTabsItems: "Items",
	
	feedsTableHeaderFeed: "Feed",
	feedsTableHeaderLoad: "Load",
	feedsTableHeaderLocation: "Location",

	feedsTableTooltipLoad: "Load this feed.",
	feedsTableBusyLoading: "Loading feed...",
	feedsTableErrorNoLongerExists: "The feed no longer exists.",
	feedsTableErrorLoad: "An error occurred attempting to load the feed.",

	feedsTableLocationLocal: "(Local)",

	feedsTableSwitchShowRemoteLabel: "Show Remote Feeds",
	feedsTableSwitchShowRemoteTooltip: "Whether to display feeds that are remotely hosted.",

	feedsTableToolbarDelete: "Delete",

	feedsTableDeleteTitleSingle: "Delete Feed",
	feedsTableDeleteTitlePlural: "Delete Feeds",
	feedsTableDeleteMessageSingle: "Are you sure you want to delete the selected feed?",
	feedsTableDeleteMessagePlural: "Are you sure you want to delete the selected feeds?",
	feedsTableBusyDeletingSingle: "Deleting feed...",
	feedsTableBusyDeletingPlural: "Deleting feeds...",

	// --- New Menu ---
	newMenuCloneExample: "Clone example feed",
	newMenuCloneDefault: "Clone default feed",
	newMenuEmptyFeed: "Empty feed",
	newMenuBusyCloning: "Cloning feed...",
	
	// --- Tools Menu ---
	toolsMenuRepackageArchive: "Repackage Archive...",
	toolsMenuGenerateManifest: "Generate Package Manifest File...",
	
	// --- CategoryEditor 
	categoryEditorTitleCreate: "Create Category",
	categoryEditorTitleEdit: "Edit Category",

	categoryEditorTabGeneral: "General",
	categoryEditorTabThumbnail: "Thumbnail",
	categoryEditorTabBackground: "Background",

	// --- Items Table --- 
	itemsTableHeaderTitle: "Title",
	itemsTableHeaderEdit: "Edit",
	itemsTableHeaderPlay: "Play",
	itemsTableHeaderApplication: "Application",
	itemsTableHeaderDateAdded: "Date Added",

	itemsTableTooltipEdit: "Edit item",
	itemsTableTooltipPlay: "Play this item",

	itemsTableToolbarCreateItem: "Create Item",
	itemsTableToolbarCut: "Cut",
	itemsTableToolbarCopy: "Copy",
	itemsTableToolbarPaste: "Paste",
	itemsTableToolbarDelete: "Delete",
	itemsTableToolbarMore: "More",

	// --- Items Table Menu ---
	itemsMoreMenuCreateFromUrls: "Create from URLs...",
	itemsMoreMenuAddFromDropbox: "Add from Dropbox...",
	itemsMoreMenuCopyStandaloneLink: "Copy stand-alone link...",
	itemsMoreMenuAnalyze: "Analyze",

	// --- Item Editor ---
	itemEditorTitleCreate: "Create Item",
	itemEditorTitleEdit: "Edit Item",
	itemEditorTabGeneral: "General",
	itemEditorTabProperties: "Properties",
	itemEditorTabMappings: "Mappings",
	itemEditorTabDescriptions: "Descriptions",
	itemEditorTabControllers: "Controllers",
	itemEditorTabThumbnail: "Thumbnail",
	itemEditorTabBackground: "Background",
	itemEditorLoading: "Loading...",
	
	// Select Category ---
	selectCategoryLabel: "Category",
	
	// --- Editor ---
	editorButtonOk: "OK",
	editorButtonCancel: "Cancelar",
	editorButtonClose: "Fechar",
	
	// --- PropertiesTab ---
	propertiesRomUrlLabel: "ROM (URL)",
	propertiesArchiveUrlLabel: "Package archive or manifest (URL)",
	propertiesParentRomLabel: "Parent ROM (URL)",
	propertiesAdditionalRomsLabel: "Additional ROMs (URLs)",
	propertiesDiscsLabel: "Discs (URLs)",
	propertiesMediaLabel: "Media (URLs)",
	propertiesSbiLabel: "SBI files (URLs)",
	propertiesCustomBiosLabel: "Custom BIOS (optional)",
	propertiesSamplesLabel: "Samples (URL)",
	propertiesAutoStartPathLabel: "Auto-start path",

	propertiesLanguageLabel: "Language",
	propertiesLanguageTooltip: "Language used for in-game text (when supported).",

	propertiesSmsHwTypeLabel: "Hardware type",
	propertiesSmsHwTypeTooltip: "Type of console hardware to emulate.",

	propertiesGbHwTypeLabel: "Hardware type",
	propertiesGbHwTypeTooltip: "Type of Game Boy hardware to emulate.",

	propertiesGbColorsLabel: "Screen colors",
	propertiesGbColorsTooltip: "Color category to use for the screen.",

	propertiesGbBorderLabel: "Border",
	propertiesGbBorderTooltip: "Whether to display a border around the screen.",

	properties3buttonLabel: "3-button pads",
	properties3buttonTooltip: "Use 3-button control pads (6-button is the default).",

	propertiesSnesMultitapLabel: "Multitap (port #2)",
	propertiesSnesMultitapTooltip: "Use a Multitap adapter in controller port #2.",

	propertiesForcePalLabel: "Force PAL",
	propertiesForcePalTooltip: "Force PAL video mode for this game.",

	propertiesSwapControllersLabel: "Swap controllers",
	propertiesSwapControllersTooltip: "Swap controller ports (useful for games that default to port 2).",

	propertiesDisableAutoloadLabel: "Disable autoload",
	propertiesDisableAutoloadTooltip: "Disable automatic loading of media.",

	propertiesDisableTdeLabel: "Disable true drive emulation",
	propertiesDisableTdeTooltip: "Disable true drive emulation for disk drives.",

	propertiesColecoControllerLabel: "Controller",
	propertiesColecoControllerTooltip: "Controller type to use for this game.",

	properties6buttonLabel: "6-button pads",
	properties6buttonTooltip: "Use 6-button control pads (2-button is the default).",

	propertiesMapRunSelectLabel: "Map RUN/SELECT to buttons",
	propertiesMapRunSelectTooltip: "Map RUN and SELECT to standard controller buttons.",

	propertiesForceYm2413Label: "Force YM2413 FM sound",
	propertiesForceYm2413Tooltip: "Emulate the YM2413 FM sound generator (when supported).",

	propertiesDoomGameLabel: "Game",
	propertiesDoomGameTooltip: "Which classic DOOM game to play.",

	propertiesRotatedLabel: "Rotated",
	propertiesRotatedTooltip: "Rotate the screen and controls.",

	propertiesRotationLabel: "Rotation",
	propertiesRotationTooltip: "How many degrees the screen should be rotated.",
	
	properties0Degrees: "0º Degrees",
	properties90Degrees: "90º Degrees",
	properties180Degrees: "180 Degreesº",
	properties270Derees: "270º Degrees",
	

	propertiesRegionLabel: "Region",
	propertiesRegionTooltip: "Console region.",
	propertiesRegionUs: "United States.",
	propertiesRegionJp: "Japan.",
	propertiesRegionEu: "Europe.",

	propertiesRegionAutoLabel: "Region",
	propertiesRegionAutoTooltip: "Game region / video standard.",

	propertiesDosControllerModeLabel: "Controller mode (initial)",
	propertiesDosControllerModeTooltip: "Initial mode for the controller.",

	propertiesJiffydosLabel: "Use JiffyDOS",
	propertiesJiffydosTooltip: "Use JiffyDOS when BIOS files are available.",

	propertiesSaveTypeLabel: "Save type",
	propertiesSaveTypeTooltip: "Type of save hardware used by the cartridge.",

	propertiesFlashSizeLabel: "Flash size",
	propertiesFlashSizeTooltip: "Size of flash RAM (only for flash save type).",

	propertiesRtcLabel: "Real-time clock",
	propertiesRtcTooltip: "Cartridge uses a real-time clock.",

	propertiesMirroringLabel: "Mirroring",
	propertiesMirroringTooltip: "Cartridge uses mirrored memory addresses.",

	propertiesDisableLookupLabel: "Disable game lookup",
	propertiesDisableLookupTooltip: "Skip automatic game lookup and its default settings.",

	propertiesNeogeoBiosLabel: "Neo Geo BIOS",
	propertiesNeogeoBiosTooltip: "Which Neo Geo BIOS to use (must be available).",

	propertiesNeogeoForceAesLabel: "Force AES (console) mode",
	propertiesNeogeoForceAesTooltip: "Force AES home-console mode (if supported by the BIOS).",

	propertiesAnalogModeLabel: "Analog mode",
	propertiesAnalogModeTooltip: "Enable analog mode on controllers.",

	propertiesTwinStickLabel: "Twin stick",
	propertiesTwinStickTooltip: "Enable twin-stick style controls.",

	propertiesMultitapLabel: "Multitap",
	propertiesMultitapTooltip: "Use a Multitap adapter.",

	propertiesSkipBiosLabel: "Skip BIOS",
	propertiesSkipBiosTooltip: "Skip BIOS intro animation when starting a game.",

	propertiesDisableMemCard1Label: "Disable memory card 1",
	propertiesDisableMemCard1Tooltip: "Disable memory card 1 (card 0 will still be available).",

	propertiesSkipCdLoadingLabel: "Skip CD loading",
	propertiesSkipCdLoadingTooltip: "Auto fast-forward CD loading screens.",

	propertiesCdSpeedHackLabel: "CD speed hack",
	propertiesCdSpeedHackTooltip: "Patch the CD-ROM BIOS for faster loading (helps on slow devices).",

	properties3doHackLabel: "Hack",
	properties3doHackTooltip: "Specific hack to apply to this 3DO game.",

	propertiesSaveDisksLabel: "Save disks",
	propertiesSaveDisksTooltip: "Number of save disks available.",

	propertiesC64RamExpansionLabel: "RAM expansion",
	propertiesC64RamExpansionTooltip: "Additional RAM expansion for the C64.",

	propertiesScreenLayoutLabel: "Screen layout",
	propertiesScreenLayoutTooltip: "Layout of DS screens.",

	propertiesScreenGapLabel: "Screen gap",
	propertiesScreenGapTooltip: "Show a visible gap between DS screens.",

	propertiesBookModeLabel: "Book mode",
	propertiesBookModeTooltip: "Orient DS in book (sideways) mode.",

	propertiesMicrophoneLabel: "Microphone supported",
	propertiesMicrophoneTooltip: "Game supports use of a microphone.",

	propertiesDualAnalogLabel: "Dual analog (stylus)",
	propertiesDualAnalogTooltip: "Use the stylus to mimic dual-analog controls.",
	
	
	// --- GenerateManifestDialog ---
	generateManifestTitle: "Generate Package Manifest File",
	generateManifestOk: "Generate",
	generateManifestTabGenerate: "Generate",
	generateManifestDescription: "Select a folder that contains the contents to generate the manifest file for.",
	generateManifestHint: "(For example, the root folder of a game)",
	generateManifestRootLabel: "Package Root Folder",
	generateManifestSelectButton: "Select folder...",
	
	// --- RepackageDialog ---
	repackageTitle: "Repackage Archive",
	repackageOk: "Repackage",
	repackageTabLabel: "Repackage",
	repackageDescription: "Select an archive (.zip) file to repackage.",
	repackageBusy: "Repackaging archive...",
	repackageError: "An error occurred while attempting to repackage the archive.",
	repackageArchiveLabel: "Package Archive",
	repackageArchiveButton: "Select file...",
	repackageCloudSwitchLabel: "Output to Cloud Storage",
	repackageCloudSwitchTooltip: "Whether to repackage and save the output to cloud storage.",
	repackageDestFolderLabel: "Destination Folder",
	repackageSelectFolderButton: "Select folder...",
	repackageSubfolderLabel: "Sub-folders to Create (optional)",
	repackageSubfolderTooltip: "One or more sub-folders to create. Multiple sub-folders must be separated by a forward slash.",
	
	// --- CopyLinkDialog ---
	copyLinkTitle: "Copy stand-alone link",
	copyLinkShortenedLabel: "Shortened URL",
	copyLinkSuccess: "Successfully copied stand-alone link (URL) to clipboard.",
	copyLinkShortenError: "An error occurred while attempting to shorten the URL.",
	copyLinkButtonCopy: "Copy",
	copyLinkButtonCancel: "Cancel",
	
	// --- CreateFromUrlDialog ---
	createFromUrlTitle: "Create items from URLs",
	createFromUrlTabUrl: "URL",
	createFromUrlFieldLabel: "URLs (one per line)",
	createFromUrlHelperSingle: "1 URL entered.",
	createFromUrlHelperMany: "URLs entered.",

	// --- BusyScreen ---
	busyDefaultMessage: "Processing...",
	
	// --- ThumbnailTab
	thumbnailLabel: "Thumbnail location (URL)",
	
	// --- BackgroundTab --- 
	backgroundLocationLabel: "Background location (URL)",
	backgroundPixelatedLabel: "Pixelated Scaling",
	backgroundPixelatedTooltip: "Whether to pixelate the image when scaling (versus applying a bilinear filter). Recommended for small screenshots.",

	// --- EditorSwitch -000
	switchOn: "Enabled",
	switchOff: "Disabled",
	switchDefaultTooltip: "Toggle this option.",
	
	// --- SelectType ---
	selectTypeApplication: "Application",
	selectTypeGroupGeneral: "General (Aliased)",
	selectTypeGroupSpecific: "Specific",
	
	// --- EditorFileChooser ---
	editorFileChooserSelect: "Select file",
	
	// --- CommonTable ---
	commonTableSortedDescending: "sorted descending",
	commonTableSortedAscending: "sorted ascending",
	commonTableSelectedSingular: "selected",
	commonTableSelectedPlural: "selected",
	commonTableRowsPerPage: "Rows per page:",
	commonTableOf: "of",
	
	// --- CommonImage --- 
	commonImageAspectRatioWarning: "Thumbnail has been sized to a {{ratio}} aspect ratio.",
	commonImageNotFound: "The specified image does not exist.",
	
	//EMULATORS STRINGS _-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-_
	
	//A2600ControllersTab	
	a2600PaddleSensitivity: "Paddle Sensitivity",
	a2600PaddleCenter: "Paddle Center",
	a2600PaddleDefaultMark: "Default",

	a2600ControllerPorts: "Controller Ports",
	a2600ControllerJoystick: "Joystick",
	a2600ControllerPaddle: "Paddle",
	a2600ControllerTwoPaddles: "2 Paddles",

	a2600VerticalPaddleOrientation: "Vertical Paddle Orientation",
	a2600InvertPaddleInput: "Invert Paddle Input",

	swapControllersLabel: "Swap Controllers",
	swapControllersTooltip: "Whether to swap the controller ports. This is typically enabled when games default to using port 2 (versus port 1).",
	
	//A5200MappingsTab
	a5200MappingsDescription: "Create game-specific mappings from Atari 5200 keys and buttons to the gamepad.",

	a5200MappingsNone: "(none)",
	a5200Start: "Start",
	a5200Pause: "Pause",
	a5200Reset: "Reset",
	a5200KeypadPrefix: "Keypad",
	a5200TopFire: "Top Fire",
	a5200BottomFire: "Bottom Fire",

	a5200ButtonALabel: "A button",
	a5200ButtonBLabel: "B button",
	a5200ButtonXLabel: "X button",
	a5200ButtonYLabel: "Y button",
	a5200LeftBumperLabel: "Left bumper",
	a5200RightBumperLabel: "Right bumper",
	a5200LeftTriggerLabel: "Left trigger",
	a5200RightTriggerLabel: "Right trigger",
	
	//C64MappingOptions
	c64JoyLeft: "Joystick Left",
	c64JoyRight: "Joystick Right",
	c64JoyUp: "Joystick Up",
	c64JoyDown: "Joystick Down",

	c64Fire1: "Fire 1",
	c64Fire2: "Fire 2",

	c64RunStop: "Run/Stop",
	c64Home: "Home",
	c64Delete: "Delete",
	c64Control: "Control",
	c64Restore: "Restore",
	c64CommodoreKey: "Commodore Key",
	c64LeftShift: "Left Shift",
	c64RightShift: "Right Shift",
	c64Return: "Return",

	c64CursorUp: "Cursor Up",
	c64CursorDown: "Cursor Down",
	c64CursorLeft: "Cursor Left",
	c64CursorRight: "Cursor Right",

	c64Space: "Space Bar",	
	
	//C64MappingsTab
	c64MapIntro: "Create game-specific mappings from the Commodore keys and joystick to the gamepad.",
	c64MapNone: "(none)",

	c64MapStart: "Start",
	c64MapAButton: "A button",
	c64MapBButton: "B button",
	c64MapXButton: "X button",
	c64MapYButton: "Y button",
	c64MapLeftBumper: "Left bumper",
	c64MapRightBumper: "Right bumper",
	c64MapLeftTrigger: "Left trigger",
	c64MapRightTrigger: "Right trigger",
	c64MapRightAnalogLeft: "Right analog left",
	c64MapRightAnalogRight: "Right analog right",
	c64MapRightAnalogUp: "Right analog up",
	c64MapRightAnalogDown: "Right analog down",
	
	//ColecoDescriptionsTab
	colecoDescIntro: "Provide game-specific descriptions for the ColecoVision controller keys and buttons.",

	colecoDescKeypad1: "Keypad 1",
	colecoDescKeypad2: "Keypad 2",
	colecoDescKeypad3: "Keypad 3",
	colecoDescKeypad4: "Keypad 4",
	colecoDescKeypad5: "Keypad 5",
	colecoDescKeypad6: "Keypad 6",
	colecoDescKeypad7: "Keypad 7",
	colecoDescKeypad8: "Keypad 8",
	colecoDescKeypad9: "Keypad 9",
	colecoDescKeypadStar: "Keypad *",
	colecoDescKeypad0: "Keypad 0",
	colecoDescKeypadHash: "Keypad #",

	colecoDescFireLeft: "Left fire",
	colecoDescGasButton: "Gas button",
	colecoDescYellowButton: "Yellow button",
	colecoDescFireRight: "Right fire",
	colecoDescBrakeButton: "Brake button",
	colecoDescOrangeButton: "Orange button",

	colecoDescLeftFire2p: "Left fire (2p)",
	colecoDescRightFire2p: "Right fire (2p)",
	colecoDescPurpleButton: "Purple button",
	colecoDescBlueButton: "Blue button",	
	
	//ColecoMappingsTab
	colecoMapIntro: "Create game-specific mappings from the ColecoVision keys and buttons to the gamepad.",

	colecoMapNone: "(none)",

	colecoMapAButton: "A button",
	colecoMapBButton: "B button",
	colecoMapXButton: "X button",
	colecoMapYButton: "Y button",
	colecoMapLeftBumper: "Left bumper",
	colecoMapRightBumper: "Right bumper",
	colecoMapLeftTrigger: "Left trigger",
	colecoMapRightTrigger: "Right trigger",
	
	//DOS MouseSpeed.js
	mouseSpeedLabel: "Mouse speed",
	mouseSpeedDefault: "Default",
	
	//GB SelectPalette
	selectPaletteGrayscaleLabel: "Grayscale Palette",
	selectPaletteGrayscaleTooltip: "The particular grayscale palette to use.",

	selectPaletteGreenscaleLabel: "Greenscale Palette",
	selectPaletteGreenscaleTooltip: "The particular greenscale palette to use.",

	selectPaletteSgbLabel: "Super Game Boy Palette",
	selectPaletteSgbTooltip: "The particular Super Game Boy palette to use.",
	
		
	// --- QUAKE ENGINE WadSelector ---
	quakePrimaryWadLabel: "Primary game file (.wad)",
	quakePrimaryWadTooltip: "The primary game file to launch (.wad file).",

	quakeAutoDetect: "Auto-detect",
	quakeBaseGame: "Quake",
	quakeScourge: "Scourge of Armagon (Pack 1)",
	quakeDissolution: "Dissolution of Eternity (Pack 2)",
	quakeDopa: "Dimension of the Past (Pack 3)",
	quakeCustom: "Custom",

	quakeWadPath: "Game file path",
	
    // --- Language Selector ---
    languageEnglish: "English",
    languagePortugueseBrazil: "Portuguese (Brazil)",
  },
    
	//VERSÃO EM PORTUGUES -----------------------------------------------------------------------------
  pt: {
    // --- App / Geral ---
    appTitle: "Editor Meu Retrô Box",
    loading: "Carregando...",
    yes: "Sim",
    no: "Não",
    ok: "OK",
    cancel: "Cancelar",
    confirm: "Confirmar",
    close: "Fechar",

    // --- Menu ---
    menuFile: "Arquivo",
    menuFileNewFeed: "Novo Feed",
    menuFileOpenFeed: "Abrir Feed",
    menuFileSaveFeed: "Salvar Feed",
    menuFileSaveAs: "Salvar Como...",
    menuFileClose: "Fechar",

    menuEdit: "Editar",
    menuEditUndo: "Desfazer",
    menuEditRedo: "Refazer",

    menuView: "Visualizar",
    menuViewPreviewFeed: "Pré-visualizar Feed",
    menuViewTheme: "Tema",
    menuViewThemeLight: "Claro",
    menuViewThemeDark: "Escuro",

    menuHelp: "Ajuda",
    menuHelpDocs: "Documentação",
    menuHelpAbout: "Sobre o Editor Retrô Box",

    // --- Tela inicial / Home ---
    homeTitle: "Editar Feeds",
    homeNewFeedButton: "Criar Novo Feed",
    homeOpenFeedButton: "Abrir Feed",
    homeRecentFeeds: "Feeds Recentes",
    homeSettings: "Configurações",
	
	// --- MainAppBar ---
	mainAppBarTitle: "Editor - Meu Retrô Box",
	mainAppBarSettings: "Configurações",
	mainAppBarHelp: "Ajuda",

    // --- Sidebar ---
    sidebarFeeds: "Feeds",
    sidebarCategories: "Categorias",
    sidebarAddCategory: "Adicionar Categoria",
    sidebarAddItem: "Adicionar Item",
    sidebarSearchPlaceholder: "Buscar...",
    sidebarNoResults: "Nenhum resultado",

    // --- Categorias ---
    categoryName: "Nome da Categoria",
    categoryDelete: "Excluir Categoria",
    categoryDeleteConfirm: "Tem certeza de que deseja excluir esta categoria?",

    // --- Itens / Jogos ---
    itemTitle: "Título do Item",
    itemDescription: "Descrição",
    itemThumbnail: "Miniatura",
    itemBackgroundImage: "Imagem de Fundo",
    itemLaunchCommand: "Comando de Inicialização",
    itemSystem: "Sistema / Emulador",
    itemRomUrl: "URL da ROM",
    itemContentUrl: "URL do Conteúdo",
    itemBoxArt: "Capa do Jogo",
    itemSaveChanges: "Salvar Alterações",
    itemDelete: "Excluir Item",
    itemDeleteConfirm: "Tem certeza de que deseja excluir este item?",

    // --- Diálogos de Feed ---
    dialogNewFeedTitle: "Criar novo Feed",
    dialogNewFeedNameLabel: "Nome do Feed",
    dialogNewFeedDescriptionLabel: "Descrição do Feed",
    dialogNewFeedCreateButton: "Criar",

    dialogOpenFeedTitle: "Abrir Feed por URL",
    dialogOpenFeedUrlLabel: "URL do Feed",
    dialogOpenFeedLoadButton: "Carregar",

    dialogSaveFeedExportTitle: "Exportar Feed",
    dialogSaveFeedExportMessage: "Digite um nome de arquivo para exportar seu feed",
    dialogSaveFeedExportButton: "Exportar",

    // --- Mensagens / Erros ---
    msgInvalidFeed: "Feed inválido.",
    msgUnableToLoadFeed: "Não foi possível carregar o feed.",
    msgFeedSaved: "Feed salvo com sucesso.",
    msgFeedSaveError: "Erro ao salvar o feed.",
    msgMissingRequiredFields: "Campos obrigatórios faltando.",
    msgNetworkError: "Erro de rede.",
    msgInvalidUrl: "URL inválida.",
    msgUnsupportedFormat: "Formato não suportado.",
    msgInvalidFile: "O arquivo selecionado não é válido.",

    // --- Configurações ---
    settingsTitle: "Configurações do Editor",
    settingsLanguage: "Idioma",
    settingsTheme: "Tema",
    settingsDeveloperTools: "Ferramentas de Desenvolvedor",
    settingsClearCache: "Limpar Cache",
    settingsResetDefaults: "Restaurar Padrões",
	
    // --- AINDA SEM CATEGORIA ---	
	confirmYes: "Sim",
	confirmNo: "Não",
	confirmDefaultTitle: "Confirmar",
	confirmDefaultMessage: "Você tem certeza?",



	feedTabCategories: "Categorias",
	feedTabItems: "Itens",

	categoriesToolbarNew: "Novo",

	selectedFeedEditTooltip: "Editar feed",

    // --- Editor Drawer Lateral ---
	
	editorDrawerNew: "Novo",
	editorDrawerImport: "Importar",
	editorDrawerExport: "Exportar",
	editorDrawerTest: "Testar",
	editorDrawerLoad: "Carregar",
	editorDrawerSave: "Salvar",
	editorDrawerTools: "Ferramentas",

	editorDrawerImportTooltip: "Importar um feed de uma URL ou arquivo local.",
	editorDrawerExportTooltip: "Exportar e baixar o feed.",
	editorDrawerTestTooltip: "Testar o feed no front-end do Meu Retrô Box.",
	editorDrawerLoadTooltip: "Carregar feed.",
	editorDrawerSaveTooltip: "Salvar o feed localmente.",

	msgSavingFeed: "Salvando feed...",
	msgFeedSavedSuccess: "Feed salvo com sucesso.",
	msgFeedSavedError: "Erro ao salvar o feed.",
	dialogSaveFeedTitle: "Salvar Feed",
	dialogSaveFeedOverwriteMessage: "Continuar e sobrescrever o feed existente?",
	
	// --- Dialogo de Tela ---
	importDialogTitle: "Importar Feed",
	importDialogTabUrl: "URL",
	importDialogTabFile: "Arquivo",
	importDialogFeedUrl: "Local do feed (URL)",
	importDialogSelectFile: "Selecione o arquivo do feed...",
	msgImportingFeed: "Importando feed...",
	
	// --- Dialogo de Export ---
	
	exportDialogTitle: "Exportar Feed",
	exportDialogTabExport: "Exportar",
	exportDialogCompressLabel: "Compactar (zip)",
	exportDialogCompressTooltip: "Define se o feed será compactado em ZIP.",
	exportDialogBase64Label: "Codificação Base64 (texto)",
	exportDialogBase64Tooltip: "Define se o feed será codificado em Base64.",

	// --- Feed Dialogos ---
	feedEditorTitle: "Editar Feed",
	feedEditorTabGeneral: "Geral",
	feedEditorTabProperties: "Propriedades",
	feedEditorTabThumbnail: "Miniatura",
	feedEditorTabBackground: "Plano de fundo",

	feedPropsApplicationLabel: "Aplicação",
	feedPropsApplicationTooltip: "Aplicativo (emulador etc.) para o qual você está editando as configurações do feed.",

	feedPropsAtari5200RomUrl: "ROM do Atari 5200 (URL)",
	feedPropsColecoRomUrl: "ROM de Coleco (URL)",
	feedPropsFdsBiosUrl: "ROM do Famicom Disk System (URL)",
	feedPropsLynxBootRomUrl: "ROM de boot do Lynx (URL)",
	feedPropsNeoGeoBiosUrl: "BIOS do Neo Geo (URL)",
	feedPropsNeoGeoCdBiosUrl: "BIOS do Neo Geo CD (URL)",
	feedProps3doBiosUrl: "BIOS do 3DO (URL)",
	feedProps3doFontsUrl: "Fontes do 3DO (URL)",
	feedProps3doFontsHelper: "Necessário para alguns jogos japoneses (opcional).",
	feedPropsPcecdBiosUrl: "BIOS do PC Engine CD (URL)",
	feedPropsPcfxBiosUrl: "BIOS do PC-FX (URL)",
	feedPropsPsxBiosUrls: "BIOS do PlayStation (URLs)",
	feedPropsDsBiosUrls: "BIOS do Nintendo DS (URLs)",
	feedPropsDsNickname: "Apelido",
	feedPropsSegacdBiosUrls: "BIOS do Sega CD (URLs)",
	feedPropsCommodore8bitBiosUrls: "BIOS do Commodore (8-bit) (URLs)",

	// --- Aba Geral 
	generalTabTitle: "Título",
	GeneralTabTitleLabel: "Título",
	generalTabLongTitle: "Título longo",
	generalTabDescription: "Descrição",

	// --- Categorias editor
	categoriesHeaderTitle: "Título",
	categoriesHeaderEdit: "Editar",
	categoriesHeaderItemCount: "Qtd. de itens",

	categoriesTooltipEdit: "Editar categoria",

	categoriesToolbarCreate: "Criar categoria",
	categoriesToolbarMoveUp: "Mover para cima",
	categoriesToolbarMoveDown: "Mover para baixo",
	categoriesToolbarCopy: "Copiar",
	categoriesToolbarPaste: "Colar",
	categoriesToolbarDelete: "Excluir",
	categoriesToolbarMore: "Mais",	
	
	//-- Editar Fedd
	selectedFeedEdit: "Editar feed",
	
	
	//-- Feed Dialog
	loadFeedDialogTitle: "Carregar Feed",
	loadFeedDialogTabLoad: "Carregar",
	
	//--- Feed Tables
	feedTabsCategories: "Categorias",
	feedTabsItems: "Itens",
	
	feedsTableHeaderFeed: "Feed",
	feedsTableHeaderLoad: "Carregar",
	feedsTableHeaderLocation: "Local",

	feedsTableTooltipLoad: "Carregar este feed.",
	feedsTableBusyLoading: "Carregando feed...",
	feedsTableErrorNoLongerExists: "O feed não existe mais.",
	feedsTableErrorLoad: "Ocorreu um erro ao tentar carregar o feed.",

	feedsTableLocationLocal: "(Local)",

	feedsTableSwitchShowRemoteLabel: "Mostrar feeds remotos",
	feedsTableSwitchShowRemoteTooltip: "Define se feeds hospedados remotamente serão exibidos.",

	feedsTableToolbarDelete: "Excluir",

	feedsTableDeleteTitleSingle: "Excluir feed",
	feedsTableDeleteTitlePlural: "Excluir feeds",
	feedsTableDeleteMessageSingle: "Você tem certeza que deseja excluir o feed selecionado?",
	feedsTableDeleteMessagePlural: "Você tem certeza que deseja excluir os feeds selecionados?",
	feedsTableBusyDeletingSingle: "Excluindo feed...",
	feedsTableBusyDeletingPlural: "Excluindo feeds...",
	
	// --- New Menu ---
	newMenuCloneExample: "Clonar feed de exemplo",
	newMenuCloneDefault: "Clonar feed padrão",
	newMenuEmptyFeed: "Criar feed vazio",
	newMenuBusyCloning: "Clonando feed...",
	
	// --- Tools Menu ---
	toolsMenuRepackageArchive: "Reempacotar Arquivo...",
	toolsMenuGenerateManifest: "Gerar Arquivo de Manifest do Pacote...",	
	
	// Category Editor ---
	categoryEditorTitleCreate: "Criar categoria",
	categoryEditorTitleEdit: "Editar categoria",
	categoryEditorTabGeneral: "Geral",
	categoryEditorTabThumbnail: "Miniatura",
	categoryEditorTabBackground: "Plano de fundo",
	
	// --- Items Tables
	itemsTableHeaderTitle: "Título",
	itemsTableHeaderEdit: "Editar",
	itemsTableHeaderPlay: "Jogar",
	itemsTableHeaderApplication: "Aplicação",
	itemsTableHeaderDateAdded: "Data de adição",

	itemsTableTooltipEdit: "Editar item",
	itemsTableTooltipPlay: "Jogar este item",

	itemsTableToolbarCreateItem: "Criar item",
	itemsTableToolbarCut: "Recortar",
	itemsTableToolbarCopy: "Copiar",
	itemsTableToolbarPaste: "Colar",
	itemsTableToolbarDelete: "Excluir",
	itemsTableToolbarMore: "Mais",

	// --- Items Table Menu --- 
	itemsMoreMenuCreateFromUrls: "Criar a partir de URLs...",
	itemsMoreMenuAddFromDropbox: "Adicionar pelo Dropbox...",
	itemsMoreMenuCopyStandaloneLink: "Copiar link stand-alone...",
	itemsMoreMenuAnalyze: "Analisar",
	
	// --- Item Editor --- 
	itemEditorTitleCreate: "Criar item",
	itemEditorTitleEdit: "Editar item",
	itemEditorTabGeneral: "Geral",
	itemEditorTabProperties: "Propriedades",
	itemEditorTabMappings: "Mapeamentos",
	itemEditorTabDescriptions: "Descrições",
	itemEditorTabControllers: "Controles",
	itemEditorTabThumbnail: "Miniatura",
	itemEditorTabBackground: "Plano de fundo",
	itemEditorLoading: "Carregando...",
	
	// --- Select Category ---
	selectCategoryLabel: "Categoria",
	
	// --- Editor ---
	editorButtonOk: "OK",
	editorButtonCancel: "Cancel",
	editorButtonClose: "Close",

	//PropertiesTab ---
	propertiesRomUrlLabel: "ROM (URL)",
	propertiesArchiveUrlLabel: "Pacote ou manifesto (URL)",
	propertiesParentRomLabel: "ROM pai (URL)",
	propertiesAdditionalRomsLabel: "ROMs adicionais (URLs)",
	propertiesDiscsLabel: "Discos (URLs)",
	propertiesMediaLabel: "Mídias (URLs)",
	propertiesSbiLabel: "Arquivos SBI (URLs)",
	propertiesCustomBiosLabel: "BIOS personalizada (opcional)",
	propertiesSamplesLabel: "Samples (URL)",
	propertiesAutoStartPathLabel: "Caminho de auto-inicialização",

	propertiesLanguageLabel: "Idioma",
	propertiesLanguageTooltip: "Idioma usado para os textos do jogo (quando suportado).",

	propertiesSmsHwTypeLabel: "Tipo de hardware",
	propertiesSmsHwTypeTooltip: "Tipo de console a ser emulado.",

	propertiesGbHwTypeLabel: "Tipo de hardware",
	propertiesGbHwTypeTooltip: "Tipo de hardware do Game Boy a ser emulado.",

	propertiesGbColorsLabel: "Cores da tela",
	propertiesGbColorsTooltip: "Categoria de cores usada na tela.",

	propertiesGbBorderLabel: "Borda",
	propertiesGbBorderTooltip: "Exibir ou não uma borda ao redor da tela.",

	properties3buttonLabel: "Controles de 3 botões",
	properties3buttonTooltip: "Usar controles de 3 botões (6 botões é o padrão).",

	propertiesSnesMultitapLabel: "Multitap (porta nº 2)",
	propertiesSnesMultitapTooltip: "Usar adaptador Multitap na porta de controle nº 2.",

	propertiesForcePalLabel: "Forçar PAL",
	propertiesForcePalTooltip: "Forçar o modo de vídeo PAL para este jogo.",

	propertiesSwapControllersLabel: "Inverter controles",
	propertiesSwapControllersTooltip: "Inverter as portas de controle (útil para jogos que usam a porta 2).",

	propertiesDisableAutoloadLabel: "Desativar autoload",
	propertiesDisableAutoloadTooltip: "Desativar o carregamento automático de mídias.",

	propertiesDisableTdeLabel: "Desativar True Drive Emulation",
	propertiesDisableTdeTooltip: "Desativar a emulação real das unidades de disco.",

	propertiesColecoControllerLabel: "Controle",
	propertiesColecoControllerTooltip: "Tipo de controle usado pelo jogo.",

	properties6buttonLabel: "Controles de 6 botões",
	properties6buttonTooltip: "Usar controles de 6 botões (2 botões é o padrão).",

	propertiesMapRunSelectLabel: "Mapear RUN/SELECT nos botões",
	propertiesMapRunSelectTooltip: "Mapear RUN e SELECT para botões padrão do controle.",

	propertiesForceYm2413Label: "Forçar YM2413 (FM)",
	propertiesForceYm2413Tooltip: "Emular o gerador de som FM YM2413 (quando suportado).",

	propertiesDoomGameLabel: "Jogo",
	propertiesDoomGameTooltip: "Qual jogo clássico de DOOM será executado.",

	propertiesRotatedLabel: "Rotacionar",
	propertiesRotatedTooltip: "Rotacionar a tela e os controles.",

	propertiesRotationLabel: "Rotação",
	propertiesRotationTooltip: "Quantidade de graus para rotacionar a tela.",
	
	properties0Degrees: "0º grau",
	properties90Degrees: "90º graus",
	properties180Degrees: "180º graus",
	properties270Degrees: "270º graus",
	

	propertiesRegionLabel: "Região",
	propertiesRegionTooltip: "Região do console.",
	propertiesRegionUs: "Estados unidos",
	propertiesRegionJp: "Japão",
	propertiesRegionEu: "Europa",

	propertiesRegionAutoLabel: "Região",
	propertiesRegionAutoTooltip: "Região / padrão de vídeo do jogo.",

	propertiesDosControllerModeLabel: "Modo do controle (inicial)",
	propertiesDosControllerModeTooltip: "Modo inicial utilizado pelo controle.",

	propertiesJiffydosLabel: "Usar JiffyDOS",
	propertiesJiffydosTooltip: "Usar JiffyDOS quando os arquivos de BIOS estiverem disponíveis.",

	propertiesSaveTypeLabel: "Tipo de salvamento",
	propertiesSaveTypeTooltip: "Tipo de hardware de salvamento utilizado pelo cartucho.",

	propertiesFlashSizeLabel: "Tamanho da flash",
	propertiesFlashSizeTooltip: "Tamanho da memória flash (apenas para tipo de salvamento flash).",

	propertiesRtcLabel: "Relógio em tempo real",
	propertiesRtcTooltip: "O cartucho utiliza um relógio em tempo real.",

	propertiesMirroringLabel: "Espelhamento",
	propertiesMirroringTooltip: "O cartucho utiliza endereços de memória espelhados.",

	propertiesDisableLookupLabel: "Desativar busca de jogo",
	propertiesDisableLookupTooltip: "Não buscar o jogo automaticamente nem aplicar presets padrão.",

	propertiesNeogeoBiosLabel: "BIOS do Neo Geo",
	propertiesNeogeoBiosTooltip: "Qual BIOS do Neo Geo será utilizada (precisa existir).",

	propertiesNeogeoForceAesLabel: "Forçar modo AES (console)",
	propertiesNeogeoForceAesTooltip: "Forçar modo console doméstico AES (quando suportado pela BIOS).",

	propertiesAnalogModeLabel: "Modo analógico",
	propertiesAnalogModeTooltip: "Ativar modo analógico nos controles.",

	propertiesTwinStickLabel: "Twin stick",
	propertiesTwinStickTooltip: "Ativar esquema de controle em estilo twin-stick.",

	propertiesMultitapLabel: "Multitap",
	propertiesMultitapTooltip: "Usar adaptador Multitap.",

	propertiesSkipBiosLabel: "Pular BIOS",
	propertiesSkipBiosTooltip: "Pular a animação da BIOS ao iniciar o jogo.",

	propertiesDisableMemCard1Label: "Desativar memory card 1",
	propertiesDisableMemCard1Tooltip: "Desativar o uso do memory card 1 (o 0 continua disponível).",

	propertiesSkipCdLoadingLabel: "Pular carregamento de CD",
	propertiesSkipCdLoadingTooltip: "Avançar automaticamente telas de carregamento de CD.",

	propertiesCdSpeedHackLabel: "CD speed hack",
	propertiesCdSpeedHackTooltip: "Modifica a BIOS de CD-ROM para carregar mais rápido (útil em dispositivos fracos).",

	properties3doHackLabel: "Hack",
	properties3doHackTooltip: "Hack específico a ser aplicado neste jogo de 3DO.",

	propertiesSaveDisksLabel: "Discos de salvamento",
	propertiesSaveDisksTooltip: "Quantidade de discos de salvamento disponíveis.",

	propertiesC64RamExpansionLabel: "Expansão de RAM",
	propertiesC64RamExpansionTooltip: "Tamanho da expansão de RAM para o C64.",

	propertiesScreenLayoutLabel: "Layout das telas",
	propertiesScreenLayoutTooltip: "Layout de exibição das telas do DS.",

	propertiesScreenGapLabel: "Espaço entre telas",
	propertiesScreenGapTooltip: "Exibir um espaço visível entre as telas do DS.",

	propertiesBookModeLabel: "Modo livro",
	propertiesBookModeTooltip: "Orientar o DS no modo livro (de lado).",

	propertiesMicrophoneLabel: "Suporte a microfone",
	propertiesMicrophoneTooltip: "O jogo suporta o uso de microfone.",

	propertiesDualAnalogLabel: "Dual analog (stylus)",
	propertiesDualAnalogTooltip: "Usar a caneta (stylus) para simular dois analógicos.",
	
	
	// --- GenerateManifestDialog ---
	generateManifestTitle: "Gerar arquivo de manifesto do pacote",
	generateManifestOk: "Gerar",
	generateManifestTabGenerate: "Gerar",
	generateManifestDescription: "Selecione uma pasta que contenha os arquivos para gerar o arquivo de manifesto.",
	generateManifestHint: "(Por exemplo, a pasta raiz de um jogo)",
	generateManifestRootLabel: "Pasta raiz do pacote",
	generateManifestSelectButton: "Selecionar pasta...",

	// --- RepackageDialog ---
	repackageTitle: "Reempacotar arquivo",
	repackageOk: "Reempacotar",
	repackageTabLabel: "Reempacotar",
	repackageDescription: "Selecione um arquivo de pacote (.zip) para reempacotar.",
	repackageBusy: "Reempacotando arquivo...",
	repackageError: "Ocorreu um erro ao tentar reempacotar o arquivo.",
	repackageArchiveLabel: "Arquivo de pacote",
	repackageArchiveButton: "Selecionar arquivo...",
	repackageCloudSwitchLabel: "Salvar na nuvem",
	repackageCloudSwitchTooltip: "Define se o reempacote será salvo no armazenamento em nuvem.",
	repackageDestFolderLabel: "Pasta de destino",
	repackageSelectFolderButton: "Selecionar pasta...",
	repackageSubfolderLabel: "Subpastas a criar (opcional)",
	repackageSubfolderTooltip: "Uma ou mais subpastas para criar. Separe múltiplas subpastas com uma barra (/).",

	// --- CopyLinkDialog ---
	copyLinkTitle: "Copiar link stand-alone",
	copyLinkShortenedLabel: "URL encurtada",
	copyLinkSuccess: "Link stand-alone (URL) copiado com sucesso para a área de transferência.",
	copyLinkShortenError: "Ocorreu um erro ao tentar encurtar a URL.",
	copyLinkButtonCopy: "Copiar",
	copyLinkButtonCancel: "Cancelar",
	
	// --- CreateFromUrlDialog ---
	createFromUrlTitle: "Criar itens a partir de URLs",
	createFromUrlTabUrl: "URL",
	createFromUrlFieldLabel: "URLs (uma por linha)",
	createFromUrlHelperSingle: "1 URL informada.",
	createFromUrlHelperMany: "URLs informadas.",
	
	// --- BusyScreen ---
	busyDefaultMessage: "Processando...",
	
	// --- ThumbnailTab
	thumbnailLabel: "Local da miniatura (URL)",
	
	// --- BackgroundTab --- 
	backgroundLocationLabel: "Local do background (URL)",
	backgroundPixelatedLabel: "Escala pixelada",
	backgroundPixelatedTooltip: "Define se a imagem deve ser pixelada ao aplicar escala (ao invés de usar filtro bilinear). Recomendado para screenshots pequenas.",
	
	// --- EditorSwitch ---
	switchOn: "Ativado",
	switchOff: "Desativado",
	switchDefaultTooltip: "Ative ou desative esta opção.",
	
	//SelectType
	selectTypeApplication: "Aplicativo",
	selectTypeGroupGeneral: "Geral (Alias)",
	selectTypeGroupSpecific: "Específicos",
	
	// EditorFileChooser ---
	editorFileChooserSelect: "Selecionar arquivo",
	
	// --- CommonTable ---
	commonTableSortedDescending: "ordenado em ordem decrescente",
	commonTableSortedAscending: "ordenado em ordem crescente",
	commonTableSelectedSingular: "selecionado",
	commonTableSelectedPlural: "selecionados",
	commonTableRowsPerPage: "Linhas por página:",
	commonTableOf: "de",

	// --- CommonImage --- 
	commonImageAspectRatioWarning: "A miniatura foi ajustada para a proporção {{ratio}}.",
	commonImageNotFound: "A imagem especificada não existe.",


	// EMULATORS STRINGS _-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-__-_
	
	//A2600ControllersTab	
	a2600PaddleSensitivity: "Sensibilidade do Paddle",
	a2600PaddleCenter: "Centro do Paddle",
	a2600PaddleDefaultMark: "Padrão",

	a2600ControllerPorts: "Portas de controle",
	a2600ControllerJoystick: "Joystick",
	a2600ControllerPaddle: "Paddle",
	a2600ControllerTwoPaddles: "2 Paddles",

	a2600VerticalPaddleOrientation: "Orientação vertical do paddle",
	a2600InvertPaddleInput: "Inverter entrada do paddle",

	swapControllersLabel: "Inverter controles",
	swapControllersTooltip: "Se as portas dos controles devem ser invertidas. Normalmente é ativado quando o jogo usa a porta 2 em vez da porta 1.",
	
	//A5200MappingsTab
	a5200MappingsDescription: "Crie mapeamentos específicos do jogo dos botões e teclas do Atari 5200 para o gamepad.",

	a5200MappingsNone: "(nenhum)",
	a5200Start: "Start",
	a5200Pause: "Pause",
	a5200Reset: "Reset",
	a5200KeypadPrefix: "Teclado numérico",
	a5200TopFire: "Tiro superior",
	a5200BottomFire: "Tiro inferior",

	a5200ButtonALabel: "Botão A",
	a5200ButtonBLabel: "Botão B",
	a5200ButtonXLabel: "Botão X",
	a5200ButtonYLabel: "Botão Y",
	a5200LeftBumperLabel: "Botão ombro esquerdo",
	a5200RightBumperLabel: "Botão ombro direito",
	a5200LeftTriggerLabel: "Gatilho esquerdo",
	a5200RightTriggerLabel: "Gatilho direito",
	
	//C64MappingOptions
	c64JoyLeft: "Joystick Esquerda",
	c64JoyRight: "Joystick Direita",
	c64JoyUp: "Joystick Cima",
	c64JoyDown: "Joystick Baixo",

	c64Fire1: "Tiro 1",
	c64Fire2: "Tiro 2",

	c64RunStop: "Run/Stop",
	c64Home: "Home",
	c64Delete: "Delete",
	c64Control: "Control",
	c64Restore: "Restore",
	c64CommodoreKey: "Tecla Commodore",
	c64LeftShift: "Shift Esquerdo",
	c64RightShift: "Shift Direito",
	c64Return: "Enter",

	c64CursorUp: "Cursor Cima",
	c64CursorDown: "Cursor Baixo",
	c64CursorLeft: "Cursor Esquerda",
	c64CursorRight: "Cursor Direita",

	c64Space: "Barra de Espaço",
	
	//C64MappingsTab
	c64MapIntro: "Crie mapeamentos específicos do jogo das teclas e do joystick do Commodore para o gamepad.",
	c64MapNone: "(nenhum)",

	c64MapStart: "Start",
	c64MapAButton: "Botão A",
	c64MapBButton: "Botão B",
	c64MapXButton: "Botão X",
	c64MapYButton: "Botão Y",
	c64MapLeftBumper: "Botão superior esquerdo (LB)",
	c64MapRightBumper: "Botão superior direito (RB)",
	c64MapLeftTrigger: "Gatilho esquerdo (LT)",
	c64MapRightTrigger: "Gatilho direito (RT)",
	c64MapRightAnalogLeft: "Analógico direito para a esquerda",
	c64MapRightAnalogRight: "Analógico direito para a direita",
	c64MapRightAnalogUp: "Analógico direito para cima",
	c64MapRightAnalogDown: "Analógico direito para baixo",	
	
	//ColecoDescriptionsTab
	colecoDescIntro: "Forneça descrições específicas do jogo para as teclas e botões do controle do ColecoVision.",

	colecoDescKeypad1: "Teclado numérico 1",
	colecoDescKeypad2: "Teclado numérico 2",
	colecoDescKeypad3: "Teclado numérico 3",
	colecoDescKeypad4: "Teclado numérico 4",
	colecoDescKeypad5: "Teclado numérico 5",
	colecoDescKeypad6: "Teclado numérico 6",
	colecoDescKeypad7: "Teclado numérico 7",
	colecoDescKeypad8: "Teclado numérico 8",
	colecoDescKeypad9: "Teclado numérico 9",
	colecoDescKeypadStar: "Teclado numérico *",
	colecoDescKeypad0: "Teclado numérico 0",
	colecoDescKeypadHash: "Teclado numérico #",

	colecoDescFireLeft: "Botão de tiro esquerdo",
	colecoDescGasButton: "Botão de aceleração",
	colecoDescYellowButton: "Botão amarelo",
	colecoDescFireRight: "Botão de tiro direito",
	colecoDescBrakeButton: "Botão de freio",
	colecoDescOrangeButton: "Botão laranja",

	colecoDescLeftFire2p: "Tiro esquerdo (2º jogador)",
	colecoDescRightFire2p: "Tiro direito (2º jogador)",
	colecoDescPurpleButton: "Botão roxo",
	colecoDescBlueButton: "Botão azul",
	
	//ColecoMappingsTab
	colecoMapIntro: "Crie mapeamentos específicos do jogo dos botões e teclas do ColecoVision para o gamepad.",

	colecoMapNone: "(nenhum)",

	colecoMapAButton: "Botão A",
	colecoMapBButton: "Botão B",
	colecoMapXButton: "Botão X",
	colecoMapYButton: "Botão Y",
	colecoMapLeftBumper: "Botão superior esquerdo (LB)",
	colecoMapRightBumper: "Botão superior direito (RB)",
	colecoMapLeftTrigger: "Gatilho esquerdo (LT)",
	colecoMapRightTrigger: "Gatilho direito (RT)",
	
	//DOS MouseSpeed.js
	mouseSpeedLabel: "Velocidade do mouse",
	mouseSpeedDefault: "Padrão",

	//GB SelectPalette
	selectPaletteGrayscaleLabel: "Grayscale Palette",
	selectPaletteGrayscaleTooltip: "The particular grayscale palette to use.",

	selectPaletteGreenscaleLabel: "Greenscale Palette",
	selectPaletteGreenscaleTooltip: "The particular greenscale palette to use.",

	selectPaletteSgbLabel: "Super Game Boy Palette",
	selectPaletteSgbTooltip: "The particular Super Game Boy palette to use.",
	
	// --- QUAKE ENGINE WadSelector ---
	quakePrimaryWadLabel: "Arquivo principal do jogo (.wad)",
	quakePrimaryWadTooltip: "O arquivo principal do jogo a ser iniciado (.wad).",

	quakeAutoDetect: "Auto detectar",
	quakeBaseGame: "Quake",
	quakeScourge: "Scourge of Armagon (Pacote 1)",
	quakeDissolution: "Dissolution of Eternity (Pacote 2)",
	quakeDopa: "Dimension of the Past (Pacote 3)",
	quakeCustom: "Personalizado",

	quakeWadPath: "Caminho do arquivo do jogo",
	
	
    // --- Language Selector ---
    languageEnglish: "Inglês",
    languagePortugueseBrazil: "Português (Brasil)",
  },
};

export default strings;
